import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { DeviationsTab } from '../../Compliance/DeviationsTab';
export function DeviationsPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "space-y-6",
            children: /*#__PURE__*/ _jsx(DeviationsTab, {
                programId: programId
            })
        })
    });
}
